import { render, staticRenderFns } from "./validationDeadline.vue?vue&type=template&id=0d804736&"
import script from "./validationDeadline.vue?vue&type=script&lang=ts&"
export * from "./validationDeadline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports